import { AuthConfig } from 'angular-oauth2-oidc';

import { PrivaAuthHttpOptions } from '@priva/auth/http';
import { FeatureToggleConfig } from '@priva/utilities/feature-toggles';
import { AppComponentsConfiguration } from '@priva/utilities/layout';

import { AppAnalytics } from './app-analytics.interface';
import { AppUris } from './app-uris.interface';

export class AppConfiguration {
    static from(configuration: AppConfiguration): AppConfiguration {
        return new AppConfiguration(
            configuration.name,
            configuration.uris,
            configuration.analytics,
            configuration.features,
            configuration.components,
            configuration.showUserName,
            configuration.showTenantName,
            configuration.useLegacyRouterLinkActiveDirective,
            configuration.authentication,
        );
    }

    constructor(
        readonly name: string,
        readonly uris: AppUris,
        readonly analytics: AppAnalytics,
        readonly features: FeatureToggleConfig,
        readonly components: AppComponentsConfiguration,
        readonly showUserName: boolean,
        readonly showTenantName: boolean,
        readonly useLegacyRouterLinkActiveDirective: boolean,
        readonly authentication?: PrivaAuthHttpOptions,
        readonly auth?: AuthConfig,
    ) {}
}
